<template>
    <div>
      <div class="bg-gradient"></div>
      <div class="main-page">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="search-holder mt-30 search-holder-list">
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Search by name, enquiry no, email or phone"
                    @input="(e) => (Filter = e.target.value)"
                    v-model="Filter"
                    class="search form-control"
                  />
                  <svg
                    v-if="Filter"
                    @click="resetFilter"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512.001 512.001"
                    style="enable-background: new 0 0 512.001 512.001"
                    xml:space="preserve"
                    width="14"
                    height="14"
                    class="close"
                  >
                    <g>
                      <g>
                        <path
                          d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                              L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                              c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                              l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                              L284.286,256.002z"
                        />
                      </g>
                    </g>
                  </svg>
                  <div class="input-group-append align-fix" id="button-addon4">
                    <button
                      class="btn btn-white rounded-right"
                      :disabled="!Filter"
                      @click="FilterData"
                      type="button"
                    >
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 451 451"
                        style="enable-background: new 0 0 451 451"
                        xml:space="preserve"
                      >
                        <g>
                          <path
                            d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                          s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                          C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                          s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z"
                          />
                        </g>
                      </svg>
                    </button>
                    <button
                      v-b-toggle.sidebar-right
                      class="filter-menu btn btn-filter btn-white"
                      type="button"
                    >
                      <img src="@/assets/filter.svg" alt="" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <span class="result-Text"
                    >{{ pageStart }} - {{ pageEnd }} of {{ total }}</span
                  >
                </div>
              </div>
            </div>
            <!-- Enquiry Card -->
            <div class="col-12">
              <div class="card enquiry-card m-height">
                <b-list-group class="list-group-flush">
                  <b-list-group-item
                    :to="{ name: 'EnqDetails', params: { id: item.id } }"
                    v-for="item in GetEnquiriesList"
                    :key="item.id"
                  >
                    <div class="row">
                      <div class="col-6 pr-1">
                        <span class="name ellipses" v-if="item.broker_firm_name">{{
                          item.broker_firm_name
                        }}</span>
                        <span class="project-name" v-if="item.building_name">{{
                          item.building_name
                        }}</span>
                        <span
                          class="project-name d-block mt-1"
                          v-if="item.premium_enquiry_no"
                          >{{ item.premium_enquiry_no }}</span
                        >
                      </div>
                      <div class="col-6 pl-1 text-right">
                        <span class="label label-tag danger" v-if="item.deleted_at">{{
                          'Deleted'
                        }}</span>
                        <div class="d-block" v-if="item.name">
                          <img
                            src="@/assets/UserIcon.svg"
                            alt=""
                            class="date-icon mr-1"
                          />
                          <span class="project-name ellipses-author">{{
                            item.name
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
            <!-- Right Menu Sidebar -->
            <b-sidebar
              id="sidebar-right"
              ref="sidebar-right"
              title="Advance Search"
              bg-variant="white"
              backdrop
              right
              shadow
            >
              <template v-slot="{ hide }">
                <div class="card form-card sidebar-form-card pr-enquiries">
                  <b-form
                    @submit.prevent="AdvancedFilter"
                    @reset="resetAdvancedFilter"
                  >
                    <!-- <b-form-group>
                      <label>Saved Search</label>
                      <b-form-select
                        v-model="AdvancedFilterBroker.save_search_id"
                        :options="saved_search_list"
                      ></b-form-select>
                    </b-form-group> -->
                    <b-form-group>
                      <b-form-input
                        type="text"
                        v-model="AdvancedFilterBroker.premium_enquiry_no"
                        placeholder="Enquiry Number"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group>
                      <multiselect
                        v-model="AdvancedFilterBroker.building_ids"
                        :searchable="true"
                        placeholder="Select Projects"
                        label="text"
                        track-by="value"
                        :options="premium_enq_projects"
                        :multiple="true"
                        :taggable="true"
                      ></multiselect>
                    </b-form-group>
                    <b-form-group>
                      <multiselect
                        v-model="AdvancedFilterBroker.broker_ids"
                        :searchable="true"
                        placeholder="Broker Firm"
                        label="text"
                        track-by="value"
                        :options="brokersList"
                        :multiple="true"
                        :taggable="true"
                      ></multiselect>
                    </b-form-group>
                    <b-form-group>
                      <multiselect
                        v-model="AdvancedFilterBroker.status_ids"
                        :searchable="true"
                        placeholder="Select Status"
                        label="text"
                        track-by="value"
                        :options="premium_enq_statuses"
                        :multiple="true"
                        :taggable="true"
                      ></multiselect>
                    </b-form-group>
                    <b-form-group>
                      <multiselect
                        v-model="AdvancedFilterBroker.broker_uuids"
                        :searchable="true"
                        placeholder="Select Broker UUID"
                        label="text"
                        track-by="value"
                        :options="brokers_uuids"
                        :multiple="true"
                        :taggable="true"
                      ></multiselect>
                    </b-form-group>
                    <b-form-group>
                      <multiselect
                        v-model="AdvancedFilterBroker.meeting_executive_ids"
                        :searchable="true"
                        placeholder="Select Field Executive"
                        label="text"
                        track-by="value"
                        :options="AssignedTo"
                        :multiple="true"
                        :taggable="true"
                      ></multiselect>
                    </b-form-group>

                    <b-form-group>
                      <b-form-select
                        v-model="AdvancedFilterBroker.delete_filter"
                        :options="DeletedList"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group label="Created Date">
                      <div class="row">
                        <div class="col-6 pr-1">
                          <datetime
                            type="date"
                            v-model="AdvancedFilterBroker.created_at_from"
                            placeholder="Start Date"
                          ></datetime>
                        </div>
                        <div class="col-6 pl-1">
                          <datetime
                            type="date"
                            v-model="AdvancedFilterBroker.created_at_upto"
                            placeholder="End Date"
                          ></datetime>
                        </div>
                      </div>
                    </b-form-group>
                    <b-form-group label="Deleted Date">
                      <div class="row">
                        <div class="col-6 pr-1">
                          <datetime
                            type="date"
                            v-model="AdvancedFilterBroker.deleted_at_from"
                            placeholder="Start Date"
                          ></datetime>
                        </div>
                        <div class="col-6 pl-1">
                          <datetime
                            type="date"
                            v-model="AdvancedFilterBroker.deleted_at_upto"
                            placeholder="End Date"
                          ></datetime>
                        </div>
                      </div>
                    </b-form-group>

                    <b-form-group class="btn-fixed">
                      <b-button
                        variant="primary"
                        type="submit"
                        block
                        @click="hide"
                        >Search</b-button
                      >
                      <b-button variant="primary-outline" block type="reset"
                        >Reset</b-button
                      >
                    </b-form-group>
                  </b-form>
                </div>
              </template>
            </b-sidebar>
            <!-- modal -->
          </div>
          <paginate
            v-if="totalPages > 1"
            v-model="pageNo"
            :page-count="totalPages"
            :click-handler="goToPage"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            :container-class="'pagination justify-content-center'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Multiselect from "vue-multiselect";
  import { Datetime } from "vue-datetime";
  import qs from "qs";
  import {
    paramsFromQuery,
    preparePremiumEnquiriesSearchParams,
  } from "@/assets/scripts/utility.js";
  export default {
    components: {
      datetime: Datetime,
      Multiselect,
    },
    data() {
      return {
        // saved_search_list: [],
        search_name: null,
        saveSearchModal: false,
        dead_reason_seq_ids: [],
        assigned_to: [],
        enquiry_statuses: [],
        advSearchParams: [],
        GetEnquiriesList: [],
        total: 0,
        perPage: 0,
        Filter: this.$route.query.search_query,
        AdvancedFilterBroker: {
          premium_enquiry_no: null,
          created_at_from: null,
          created_at_upto: null,
          delete_filter: null,
          deleted_at_from: null,
          deleted_at_upto: null,
          broker_ids: [],
          building_ids: [],
          status_ids: [],
          broker_uuids: [],
          meeting_executive_ids: [],
        },
        DeletedList: [
          { value: null, text: "Deleted?" },
          { value: true, text: "Yes" },
          { value: false, text: "No" },
        ],
      };
    },
    computed: {
      brokersList() {
        return this.$store.getters.brokersMaster;
      },
      AssignedTo() {
        return this.$store.getters.AssignedToMaster;
      },
      premium_enq_projects() {
        return this.$store.getters.premium_enq_projects;
      },
      premium_enq_statuses() {
        return this.$store.getters.premium_enq_statuses;
      },
      brokers_uuids() {
        return this.$store.getters.brokers_uuids;
      },
      totalPages() {
        if (this.total === 0 || this.perPage === 0) {
          return 0;
        } else {
          return Math.ceil(this.total / this.perPage);
        }
      },
      pageNo: {
        get() {
          let pageNo = this.$route.query.pageNo || 1;
          return parseInt(pageNo);
        },
        set() {
          true;
        },
      },
      pageStart() {
        if (this.total === 0) {
          return 0;
        }
        return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
      },
      pageEnd() {
        if (this.total === 0) {
          return 0;
        }
        return Math.min(this.total, this.pageNo * this.perPage);
      },
    },
    mounted() {
      this.FetchEnquiriesList();
    },
    watch: {
      $route(to, from) {
        this.FetchEnquiriesList();
      },
    },
    methods: {
      FetchEnquiriesList() {
        let queryP = {};
        if (this.$route.query.is_advanced_search) {
          let searchParams = this.$route.query;
          for (let key in searchParams) {
            queryP[key] = searchParams[key];
          }
          this.advSearchParams = queryP;
        }
        if (this.advSearchParams.length > 0) {
          paramsFromQuery(queryP, this.advSearchParams);
        } else {
          paramsFromQuery(queryP, this.$route.query);
        }
        this.$axios
          .get(`premium_enquiries`, {
            params: queryP,
            paramsSerializer: (params) =>
              qs.stringify(params, {
                arrayFormat: "brackets",
              }),
          })
          .then((res) => {
            this.GetEnquiriesList = res.data.premium_enquiries;
            this.perPage = res.data.per_page;
            this.total = res.data.total_count;
          });
      },
      AdvancedFilter() {
        let searchParams = preparePremiumEnquiriesSearchParams(
          this.AdvancedFilterBroker
        );
        let newQ = { ...searchParams, is_advanced_search: true };
        this.$router.replace({ query: newQ });
      },
      // getSavedSearch() {
      //   this.$axios.get(`enquiries_builders/search_histories`).then((res) => {
      //     this.saved_search_list = [];
      //     res.data.search_history.forEach((item, index) => {
      //       this.saved_search_list.push({ value: item.id, text: item.name });
      //     });
      //     this.saved_search_list.unshift({
      //       value: null,
      //       text: "Select Saved Search",
      //     });
      //   });
      // },
      resetAdvancedFilter() {
        this.AdvancedFilterBroker = {};
        this.dead_reason_seq_ids = [];
        this.assigned_to = [];
        this.broker_ids = [];
        this.enquiry_statuses = [];
        let rQ = this.$route.query;
        if (rQ.is_advanced_search) {
          this.$router.replace({
            query: {},
          });
        }
      },
      goToPage(pageNo) {
        let newQ = {
          ...this.$route.query,
          pageNo,
        };
        this.$router.replace({
          query: newQ,
        });
      },
      resetFilter() {
        let rQ = this.$route.query;
        this.Filter = "";
        if (rQ.search_query) {
          let { search_query, ...newQ } = rQ;
          this.$router.replace({
            query: newQ,
          });
        }
      },
      FilterData() {
        if (this.Filter) {
          let newQ = {
            ...this.$route.query,
            search_query: this.Filter,
          };
          this.$router.replace({
            query: newQ,
          });
        }
      },
    },
  };
  </script>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style>
  .multiselect__tags {
    min-height: 50px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #f6f6f6;
    font-size: 14px;
  }
  .today-call{
    width:100%;
    justify-content:space-between;
    padding: 0 15px;
  }
  .pagination {
    margin-top: 40px;
    padding-bottom: 100px;
  }
  .multiselect__tag {
    /* background: #41b883; */
    background: #233445;
  }
  .mb-fix {
    margin-bottom: 3px;
  }

  .pr-enquiries .multiselect input{
    border: transparent;
  }

  .enquiry-card .label-tag{
    border-radius: 4px;
  }

  .enquiry-card .label-tag.danger{
    color: #DA3F0D;
    background-color: #FFE6E6;
  }

  </style>